import { api } from 'data/api/api'

import { DeleteFeedbackCommentArgs, FeedbackCommentResp } from '../types/feedback-comment'

export const deleteFeedbackComment = ({ feedbackId }: DeleteFeedbackCommentArgs) =>
  api.put<FeedbackCommentResp>(`/user_feedbacks/${feedbackId}/comment`, { comment: null })
